/*
* @描述: 新增报价单
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2024-12-17 17:37:13
*/
<template>
    <div class="quotation_add_page">
        <div class="quotation_add_header">
            <div class="back_btn flex_wrap" @click="handleClickReturn">
                <i class="el-icon-arrow-left"></i>
                <span class="back_text">返回</span>
            </div>
            <span class="line"></span>
            <div class="page_title">新增报价单</div>
        </div>
        <div class="quotation_add_content">
            <div class="quotation_add_form_wrap">
                <div class="quotation_add_form_top">
                    <div v-if="!understood" class="quotation_add_hint">
                        <div class="flex_wrap">
                            <i class="iconfont icon-tishi"></i>
                            <p class="hint_text">提示：长按拖动字段更换顺序；鼠标移入各行可以添加或删除行，可以在空白表格中自行填写字段名称与内容</p>
                        </div>
                        <el-link :underline="false" type="primary" @click="understood=true">知道了</el-link>
                    </div>
                    <TemplateComponent :project_quotation_tmpl_form="project_quotation_tmpl_form"
                                       :form_snapshot_key="form_snapshot_key"
                                       :project_quotation_id="project_quotation_id"
                                       ref="templateComponent"
                                       :templateType="'add'"/>
                    <div v-if="isApproval===1" class="add_approval_select_process mt_16">
                        <div class="page_little_title">
                            <span class="title">审批流程</span>
                        </div>
                        <approveProcessSelect ref="approveProcessSelectRef"
                                              :approval_node_list="approval_node_list">
                        </approveProcessSelect>
                    </div>
                </div>
                <div class="quotation_add_form_footer">
                    <el-button plain size="small" type="primary" @click="handleClickReplaceTemplate">更改模版</el-button>
                    <el-button size="small" type="primary" @click="handleClickSubmit">提交</el-button>
                </div>
            </div>
        </div>
        <quotationTemplate v-if="addQuotationDialogVisible"
                           :dialogVisible.sync="addQuotationDialogVisible"/>
    </div>
</template>
<script>
    import TemplateComponent from "@/views/pc/Business/component/template_component";
    import quotationTemplate from "./component/quotation_template";
    import approveProcessSelect from "@/components/pComponents/approveProcessSelect";
    import {getApprovalNodes, projectQuotationAdd} from "@/api";
    import {getBusinessIsApproval} from "@/utils";
    import {EventBus} from '@/utils/eventBus';

    export default {
        name: "QuotationAdd",
        data() {
            return {
                project_quotation_tmpl_form: this.$route.query.project_quotation_tmpl_form,
                project_quotation_id: this.$route.query.hasOwnProperty('project_quotation_id') ? Number(this.$route.query.project_quotation_id) : 0,
                form_snapshot_key: this.$route.query.form_snapshot_key || '',
                understood: true,
                addQuotationDialogVisible: false,
                isApproval: 0,
                approval_node_list: [],
            }
        },
        components: {TemplateComponent, quotationTemplate, approveProcessSelect},
        created() {
            getBusinessIsApproval('quotation_add').then(res => {
                this.isApproval = res
                if (this.isApproval === 1) {
                    getApprovalNodes({
                        approval_type: 'quotation_add',
                    }).then(res => {
                        if (res.code === 200) {
                            this.approval_node_list = res.data
                            this.$refs.approveProcessSelectRef.set_approval_node_list(res.data)
                        } else {
                            this.$message.error(res.message)
                        }
                        this.loading = false
                    }).catch(() => {
                        this.loading = false
                    })
                }
            })
        },
        computed: {},
        mounted() {

        },
        methods: {
            //返回
            handleClickReturn() {
                this.$router.go(-1)
            },

            //更改模板
            handleClickReplaceTemplate() {
                this.addQuotationDialogVisible = true
            },

            //提交
            handleClickSubmit() {
                const {templateFieldsList, quotationForm} = this.$refs.templateComponent
                if (!quotationForm.title) return this.$message.error('请输入标题')
                if (!quotationForm.company_logo) return this.$message.error('请上传公司logo')
                const data = {
                    ...quotationForm,
                    project_quotation_tmpl_form: this.project_quotation_tmpl_form,
                    custom_fields: templateFieldsList,
                    create_project: false,
                }
                if (quotationForm.project_id === '' && quotationForm.project_name.value !== '') {
                    this.$msgbox({
                        title: '提示',
                        message: '是否自动创建商机，用于项目流程的整体管理',
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        iconClass: 'iconfont icon-shuoming',
                        showCancelButton: true,
                        closeOnClickModal: false,
                        closeOnPressEscape: false,
                        customClass: 'icon_title_message_box icon_title_message_box_warning'
                    }).then(() => {
                        data.create_project = true
                        this.requestFunction(data)
                    }).catch(() => {
                        data.create_project = false
                        this.requestFunction(data)
                    })
                } else {
                    data.create_project = false
                    this.requestFunction(data)
                }
            },

            requestFunction(data) {
                if (this.isApproval === 1 && !this.$refs.approveProcessSelectRef.handleClickPublish()) return false
                projectQuotationAdd({
                    ...data,
                    node_list: this.approval_node_list,
                }).then(res => {
                    if (res.code === 200) {
                        this.$message.success('新增成功')
                        this.$router.back()
                        EventBus.$emit('quotationUpdated');
                    } else {
                        this.$message.error(res.message)
                    }
                })
            }
        },
    }
</script>
<style lang="scss" scoped>
    .quotation_add_page {
        width: 100%;
        height: 100%;

        .quotation_add_header {
            padding: 12px 16px;
            background-color: #FFFFFF;
            display: flex;
            align-items: center;

            .back_btn {
                cursor: pointer;

                .back_text {
                    font-size: 16px;
                    font-weight: 400;
                    line-height: 24px;
                    color: #666666;
                }
            }

            .page_title {
                font-size: 16px;
                font-weight: 700;
                line-height: 24px;
                color: #333333;
            }
        }

        .quotation_add_content {
            width: 100%;
            height: calc(100% - 49px);
            background-color: #EDF0F4;

            .quotation_add_form_wrap {
                width: 1016px;
                height: 100%;
                margin: 0 auto;
                background-color: #FFFFFF;
                border-radius: 8px;

                .quotation_add_form_top {
                    width: 100%;
                    height: calc(100% - 52px);
                    padding: 24px;
                    overflow-y: auto;

                    .quotation_add_hint {
                        padding: 9px 16px;
                        border-radius: 4px;
                        background: rgba(41, 144, 255, 0.16);
                        border: 1px solid rgba(41, 144, 255, 0.34);
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        margin-bottom: 16px;

                        .icon-tishi {
                            color: #2990FF;
                        }

                        .hint_text {
                            line-height: 22px;
                            color: #333333;
                            margin-left: 4px;
                        }
                    }
                }

                .quotation_add_form_footer {
                    padding: 10px 0;
                    text-align: center;
                    box-shadow: 0px -1px 0px rgba(0, 0, 0, 0.08);
                }
            }
        }
    }
</style>
